/**
 * Here there are the javascript utils for handlebars
 *
 * @author: David Pocina <dpocina[at]zerogrey[dot]com>
 *
 */

/* globals window */

(function ( $, _ ) {
	'use strict';

	// Establish the root object ('window' in the browser)
	var root = this;


	// HANDLEBARS RENDERER
	// ===================

	var handlebarsTemplates = {
		// used to cache the compiled templates
		compiled: $.extend( {}, Handlebars.templates || {} ),

		getTemplate: function ( id ) {
			return String( $( '#template-' + id ).html() ).trim() || 'Missing Template: ' + id;
		},

		registerPartial: function ( id ) {
			Handlebars.registerPartial( id, this.compiled[id] || this.getTemplate( id ) );
		},

		render: function ( type, data ) {
			var result = null;

			if ( !type ) {
				throw new Error( 'handlebars-renderer.js - called with undefined template' );
			}

			if ( root.DEBUG ) {
				result = '<div class="alert alert-danger">' +
						'<strong>HANDLEBARS Compilation Runtime Not Available:</strong><br>' +
						'Please provide a pre-compiled template for ' + type +
						'</div>';
			}

			if ( !this.compiled[type] && Handlebars.compile ) {
				this.compiled[type] = Handlebars.compile( this.getTemplate( type ) );
			}

			if ( _.isFunction( this.compiled[type] ) ) {
				result = this.compiled[type]( data );
			}

			return result;
		}
	};

	root.handlebarsTemplates = handlebarsTemplates;


	// HANDLEBARS HELPERS
	// ==================

	/**
	 *
	 */
	Handlebars.registerHelper( 'calculate', function ( lvalue, operator, rvalue, options ) {
		var result,
			operators = {
				'+': function ( l, r ) { return (+l) + (+r); },
				'-': function ( l, r ) { return (+l) - (+r); },
				'*': function ( l, r ) { return (+l) * (+r); },
				'/': function ( l, r ) { return (+l) / (+r); },
				'%': function ( l, r ) { return (+l) % (+r); }
			};

		if ( !operators[operator] ) {
			throw new Error( 'Handlebars Helper "calculate": undefined operator ' + operator );
		}

		result = operators[operator]( lvalue, rvalue );

		if ( options && options.fn ) {
			if ( result !== null ) {
				result = options.fn( this );
			} else {
				result = options.inverse( this );
			}
		}

		return result;
	} );
	
	/**
	 *
	 */
	Handlebars.registerHelper( 'isDropdownOption', function ( optionId, options ) {
		if ( !window.CMS_DROPDOWN_OPTIONS ) {
			return options.inverse();
		}
		return _.contains( window.CMS_DROPDOWN_OPTIONS, optionId ) ? options.fn( this ) : options.inverse( this );
	} );

	/**
	 *
	 */
	Handlebars.registerHelper( 'generateCmsStickers', function ( pid, categories,promotions, options ) {

		var categoryKeys  = _.keys( categories ),
			promotionKeys = ( promotions && promotions.applied ) ? _.keys( promotions.applied ) : [],
			isProduct = false,
			isAssignedToPromotion = false,
			isAssignedToCategories = false;

		if ( !window.CMS_STICKERS ) {
			return options.inverse();
		}
		return _.reduce( window.CMS_STICKERS, function ( buffer, element ) {
			// pid has to be a string
			isProduct =  _.contains( element.products, '' + pid );
			isAssignedToCategories = _.intersection( categoryKeys, element.categories ).length;
			isAssignedToPromotion = !!_.intersection( promotionKeys, element.promotions ).length;

			return ( isProduct || isAssignedToCategories || isAssignedToPromotion ) ?
			buffer + options.fn( element ) : buffer;

		}, '' );

	} );
	
	/**
	 *
	 */
		Handlebars.registerHelper( 'checkOfferSticker', function ( pid, name ) {
			const sticker = window.CMS_STICKERS.find(product => product.alt === name);
		return sticker.products.includes(pid.toString());
	} );

	/**
	 *
	 */
		Handlebars.registerHelper( 'checkProductInDeliveryList', function ( pid ) {
		return window.PRODUCT_LIST.includes( pid.toString() );
	} );
	
	/**
	 *			<div class="line">{{#each ../characteristics.1632.values}}{{this}}{{~/each~}}</div>

	 */
	Handlebars.registerHelper( 'generateCompareFields', function ( descriptions, characteristics, opts, options ) {
		
		if ( !window.CMS_COMPARE_FIELDS ) {
			return options.inverse();
		}
		return _.reduce( window.CMS_COMPARE_FIELDS, function ( buffer, element ) {
			var content = null;
			var id = element.id;
			if ( element.type == 'descriptions' ) {
				if ( descriptions )	return buffer + options.fn( descriptions[id] );
				else return buffer + '<div class="line"></div>';
			} else if ( element.type == 'characteristics' ){
				if ( characteristics && characteristics[id] )	return buffer + options.fn( Object.values(characteristics[id].values)[0] );
				else return buffer + '<div class="line"></div>';
			} else if ( element.type == 'options' ) {
				if ( opts && opts[id] ) return buffer + options.fn( Object.values(opts[id].values)[0].name );
				else return buffer + '<div class="line"></div>';
			}
		}, '' );

	} );
	
	/**
	 * Replace spaces with dashes
	 * 
	 */
	Handlebars.registerHelper('replaceSpacesWithDashes', function( string, options ) {
		return string.replace(/\s/g,'-').replace(/\//g,'').replace(/--/g,'-');
	});
	
	/**
	 *
	 */
	Handlebars.registerHelper( 'renderLowSkusPrice', function ( skus,price,related,id,pricetype ) {
		var value=0,avoidCurrency='',to_discount=0, save=0;
		if(skus && skus.length!==0){
			for (var s in skus) {
				if(value===0 || skus[s]['price']['sell'] <= value){
					value = skus[s]['price']['sell'];
					to_discount = skus[s]['price']['to_discount'];
					save = to_discount - value;
					avoidCurrency = skus[s]['currency_symbol'];
				}
			}
			var avoid = _.isBoolean(avoidCurrency ) ? avoidCurrency : false;
			if ( value != 9999.99 ) {
				if ( pricetype == 'sell' ) return new Handlebars.SafeString( to_discount > 0 && to_discount != value ? 'now ': '' + root.renderPrice(value, avoid ) );
				else if ( pricetype == 'to_discount' && to_discount > 0 && to_discount != value ) return new Handlebars.SafeString( 'RRP ' + root.renderPrice(to_discount, avoid ) );
				else if ( pricetype == 'save' && to_discount > 0 && to_discount != value ) return new Handlebars.SafeString( 'save ' + save );
			}
			else return '';
		} else if (related && related.length!==0) {
			if(value===null || value===0) {
				var relId="";
				var data = {
						products: related,
						getPrice: true,
						getSkus: true
				};

				zgPost( 'getProductsInfo', data, null, {
						success: _.bind( function ( response ) {
							if (response.products.length > 0) {
									_.each(response.products,function( prod){
										if(prod.skus){
											for (var s in prod.skus) {
												if(value===0 || value === null ||  prod.skus[s]['price']['sell'] <= value) {
														value = prod.skus[s]['price']['sell'];
														to_discount = prod.skus[s]['price']['to_discount'];
														save = to_discount - value;
														avoidCurrency= prod.skus[s]['currency_symbol'];
												}
											}
										} else {
											value = prod['price']['sell'];
											to_discount = prod['price']['to_discount'];
											save = to_discount - value;
										}
									}, this );

								var avoid = _.isBoolean( avoidCurrency ) ? avoidCurrency : false;
								if ( value != '9999.99' ) {
									$('#sell_' + id).html( '<small>From</small> ' + root.renderPrice( value, avoid ) );
									if ( to_discount > 0 && value != to_discount ) {
										$('#to_discount_' + id).html( price.to_discount > 0 && price.to_discount != price.sell ? 'was ': '' + root.renderPrice( to_discount, avoid ) ).addClass('discounted').show();
										$('#save' + id).html( 'save ' + root.renderPrice( save, avoid ) ).show();
										$('#sell_' + id).addClass('discounted');
									}
								}
							}
						}, this ),
						error: _.bind( function (response) {

						}, this )
					});
			}
		} else {
			var avoid = _.isBoolean( price.currency_symbol ) ? price.currency_symbol : false;
			if ( pricetype == 'sell' ) return new Handlebars.SafeString( price.to_discount > 0 && price.to_discount != price.sell ? 'now ' : '' + root.renderPrice(price.sell, avoid ) );
			else if ( pricetype == 'to_discount' && price.to_discount > 0 && price.to_discount != price.sell ) return new Handlebars.SafeString( 'was ' + price.to_discount );
			else if ( pricetype == 'save' && price.to_discount > 0 && price.to_discount != price.sell ) return new Handlebars.SafeString( 'save ' + save );
		}
	} );

	/**
	 *
	 */
	Handlebars.registerHelper( 'compare', function ( lvalue, operator, rvalue, options ) {
		var result,
			operators = {
				'&&':     function ( l, r ) { return l && r; },
				'||':     function ( l, r ) { return l || r; },
				'==':     function ( l, r ) { return l == r; },
				'===':    function ( l, r ) { return l === r; },
				'!=':     function ( l, r ) { return l != r; },
				'!==':    function ( l, r ) { return l !== r; },
				'<':      function ( l, r ) { return l < r; },
				'>':      function ( l, r ) { return l > r; },
				'<=':     function ( l, r ) { return l <= r; },
				'>=':     function ( l, r ) { return l >= r; },
				'typeof': function ( l, r ) { return typeof l == r; }
			};

		if ( !operators[operator] ) {
			throw new Error( 'Handlebars Helper "compare": undefined operator ' + operator );
		}

		result = operators[operator]( lvalue, rvalue );

		if ( options && options.fn ) {
			if ( result ) {
				result = options.fn( this );
			} else {
				result = options.inverse( this );
			}
		}

		return result;
	} );

	/**
	 * Replace url http with https
	 *
	 */
	Handlebars.registerHelper( 'convertToHttps', function ( url ) {
		return url.replace( 'http://', 'https://' );
	} );

	/**
	 *
	 */
	Handlebars.registerHelper( 'count', function ( variable, options ) {
		var prop, result = 0;

		if ( _.isArray( variable ) ) {

			result = variable.length;

		} else if ( _.isObject( variable ) ) {

			for ( prop in variable ) {
				if ( variable.hasOwnProperty( prop ) ) {
					result++;
				}
			}

		} else if ( !_.isNull( variable ) && !_.isUndefined( variable ) ) {

			result = 1;
		}

		if ( options && options.fn ) {
			if ( result ) {
				result = options.fn( result );
			} else {
				result = options.inverse( this );
			}
		}

		return result;
	} );

	/**
	 * Prints information about the current variable / context to the console
	 *
	 */
	Handlebars.registerHelper( 'debug', function ( value, options ) {
		if ( root.DEBUG ) { // only print debug info if the page is in DEBUG mode
			console.log( '/ -------------' );
			console.log( 'Context:', this );

			if ( value && options ) {
				console.log( '----' );
				console.log( 'Value:', value );
			}
		}
	} );

	/**
	 *
	 */
	Handlebars.registerHelper( 'encodeURIComponent', function ( component ) {
		return encodeURIComponent( component );
	} );

	/**
	 *
	 */
	Handlebars.registerHelper( 'getCurrentUrl', function () {
		return window.location.href;
	} );

	Handlebars.registerHelper( 'getCurrentUrlEncoded', function () {
		return encodeURIComponent( window.location.href );
	} );

	/**
	 *
	 */
	Handlebars.registerHelper( 'getElement', function ( context, item, options ) {
		var result;

		if ( context && context[item] ) {
			result = options.fn( context[item] );
		} else {
			result = options.inverse( this );
		}

		return result;
	} );
	Handlebars.registerHelper( 'getStar', function ( n ) {
		var result='';

		for(var i=0;i< n;i++)
			result+='<i class="fa fa-star" aria-hidden="true"></i>';

		return new Handlebars.SafeString(result);
	} );

	/**
	 * Get a js variable from the template.
	 *
	 * usage:
	 *     {{getJsVar "varName" }}
	 *     {{getJsVar "obj.path.to.var" }}
	 */
	Handlebars.registerHelper( 'getJsVar', function ( variable, options ) {
		var i,
			prop = variable.split( '.' ),
			obj  = root;

		for ( i = 0; i < prop.length && obj; i++ ) {
			if ( obj[prop[i]] ) {
				obj = obj[prop[i]];
			} else {
				obj = false;
			}
		}

		if ( options && options.fn ) {
			if ( obj ) {
				obj = options.fn( obj );
			} else {
				obj = options.inverse( this );
			}
		}

		return obj;
	} );

	/**
	 * Get all the categories
	 */
	Handlebars.registerHelper( 'getSeoCategories', function ( categories ) {
		var seoCat = [],
			index;

		for ( index in categories ) {
			if ( categories.hasOwnProperty( index ) ) {
				seoCat.push( categories[index].name );
			}
		}

		return seoCat.join( '|' );
	} );

	/**
	 *
	 */
	Handlebars.registerHelper( 'makeUrl', function ( action, manager, module ) {
		var components = {};

		if ( action ) {
			components.action = action;
		}

		if ( manager ) {
			components.manager = manager;
		}

		if ( module ) {
			components.module = module;
		}

		return root.makeUrl( components );
	} );

	/**
	 *
	 */
	Handlebars.registerHelper( 'nl2br', function ( string ) {
		return new Handlebars.SafeString( root.nl2br( string ) );
	} );

	/**
	 *
	 */
	Handlebars.registerHelper( 'preloadImage', function ( img ) {
		if ( _.isString( img ) ) {
			if ( root.IMG_VERSION ) {
				img += '?v=' + root.IMG_VERSION;
			}

			(new Image()).src = img;
		}
	} );

	/**
	 *
	 */
	Handlebars.registerHelper( 'renderPrice', function ( value, avoidCurrency, currency ) {
		var avoid = _.isBoolean( avoidCurrency ) ? avoidCurrency : false;
		
		return new Handlebars.SafeString( root.renderPrice( value, avoid, currency ) );
	} );
	
	/**
	 *
	 */
	Handlebars.registerHelper( 'renderSavePrice', function ( to_sell, to_discount, avoidCurrency, currency ) {
		var avoid = _.isBoolean( avoidCurrency ) ? avoidCurrency : false;
		var value = to_discount - to_sell;
		return new Handlebars.SafeString( root.renderPrice( value, avoid, currency ) );
	} );
	
	/**
	 *
	 */
	Handlebars.registerHelper( 'sortByName', function ( values, property, pattern, options ) {
		var array, result, i;

		if ( !options ) {
			if ( pattern ) {
				options  = pattern;
				pattern = null;
			} else {
				options  = property;
				property = null;
			}
		}

		array = root.zgSortObjectByProp( values, property, pattern );

		if ( array.length ) {
			result = '';

			for ( i = 0; i < array.length; i++ ) {
				result += options.fn( array[i], { data: { index: i } } );
			}
		} else {
			result = options.inverse( this );
		}

		return result;
	} );

	/**
	 *
	 */
	Handlebars.registerHelper( 'split', function ( value, separator ) {
		return String( value ).split( separator || ';' );
	} );



	/**
	 *
	 */
	Handlebars.registerHelper( 'toFixed', function ( number, fixedTo ) {
		// Only allow integers as parameter
		var fixedDecimals = ( typeof fixedTo === 'number' && isFinite( fixedTo ) && fixedTo % 1 === 0 ) ? fixedTo : 2;

		if ( typeof number === 'string' ) {
			number = number.replace( /,/g, '' );
		}

		return Number( number ).toFixed( fixedDecimals );
	} );

	/**
	 *
	 */
	Handlebars.registerHelper( 'translate', function ( translation ) {
		return JS_TRANSLATIONS[translation] || '>>- ' + translation + ' -<<';
	} );

	Handlebars.registerHelper( 'voucherCustomValues', function ( custom_availables, options ) {
		var result = "";
		for ( var i = 0; i < custom_availables.length; i++ ) {
			result += options.fn( custom_availables[i]);
		}
		return result;
	});

	// HANDLEBARS PARTIALS
	// ===================

	//
	handlebarsTemplates.registerPartial( 'gallery-item' );

	//
	handlebarsTemplates.registerPartial( 'image' );

	//
	handlebarsTemplates.registerPartial( 'product-availability' );
	handlebarsTemplates.registerPartial( 'product-options' );
	handlebarsTemplates.registerPartial( 'product-price' );
	handlebarsTemplates.registerPartial( 'product-shopByLook-variant' );
	handlebarsTemplates.registerPartial( 'product-shopByLook-options' );
	handlebarsTemplates.registerPartial( 'product-shopByLook-images' );
	handlebarsTemplates.registerPartial( 'product-shopByLook-price' );

	//
	handlebarsTemplates.registerPartial( 'social-share' );

	//
	handlebarsTemplates.registerPartial( 'storelocator-missing-geolocation-status' );


	// HANDLEBARS AUTOMATIC RENDERING
	// ==============================


	$( function () {
		$( '[data-zg-role="render-handlebars"]' ).each( function () {
			var $this = $( this ),
				data = $this.data();

			$this.html( root.handlebarsTemplates.render( data.template, data.content || {} ) );
			$(document).trigger('handlebars-rendered-' + data.template, []);
		} );
	} );

}.call( this, jQuery, _ ));
